module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/impostazioni-utente/impostazioni-utente.component.css
// module id = ./src/app/components/impostazioni-utente/impostazioni-utente.component.css
// module chunks = main